exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-data-table[data-v-218231dc] .sticky-header{position:sticky;top:0;z-index:1}.v-data-table[data-v-218231dc] .v-data-table__wrapper{margin-top:0;overflow:unset}.v-data-table[data-v-218231dc] tr:nth-child(2n){background-color:#fafafa}.v-chip__content[data-v-218231dc]{font-size:12px}.rowWasEdited[data-v-218231dc]{border:2px solid #ab3b7c;padding:2px}", ""]);

// exports
